import { KINDS } from '../constants'
import { validKinds } from '../types'

const isRvKind = (kind: validKinds) => {
  return kind == KINDS.RV_PULLTHROUGH || kind == KINDS.RV_BACKIN || kind == KINDS.RV_HYBRID || kind == KINDS.RV_PULLIN
}

export default isRvKind
